export const environment = {
    apiUrl: 'https://projects.lestes.tech/sudoku'
}